import script from "./UserAuFinancial.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserAuFinancial.vue?vue&type=script&setup=true&lang=ts"

import "./UserAuFinancial.vue?vue&type=style&index=0&id=f2da0d38&scoped=true&lang=scss"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2da0d38"]])

export default __exports__